import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import cl from '../BaseSimplePage/BaseSimpleItemEditor.module.css'
import ServerManager from "../../API/ServerManager";
import BaseSimpleItemEditorHeader from "../BaseSimplePage/BaseSimpleItemEditorHeader";
import {Alert, LinearProgress} from "@mui/material";
import BaseSimpleItemEditorFooter from "../BaseSimplePage/BaseSimpleItemEditorFooter";
import EventsMuseumItemForm from "../EventsMuseumPage/EventsMuseumItemForm";

const EventDraftsNewEventItemEditor = forwardRef(({
                                    renderFooterFunc,
                                    onAdd,
                                    onDelete,
                                    onSave,
                                    setSnackbarData,
                                    setLoadingOverlayData,
                                    sourceDraftId,
                                }, ref) => {

    useImperativeHandle(ref, () => ({
        tryValidateAndGetFormData: tryValidateAndGetFormData,
        tryGetInitData: tryGetInitData,
    }));

    const [isLoading, setIsLoading] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [formData, setFormData] = useState(null);
    const [draftFormData, setDraftFormData] = useState(null);
    const [formKey, setFormKey] = useState(0);
    const formControlRef = useRef(null);

    // получение данных с сервера (для драфта) (один раз)
    useEffect(() => {
        async function fetch() {
            setIsLoading(true);
            setDraftFormData(null);
            try {
                const itemData = await ServerManager.getSimpleModeItem("event-draft", sourceDraftId);
                if (!ignore) {
                    setDraftFormData(itemData);
                }
            } catch (error) {
                if (!ignore) {
                    setErrorMessage(`Ошибка при загрузке данных: ${error}`);
                }
            } finally {
                if (!ignore) setIsLoading(false);
            }
        }

        setFormData(null);

        let ignore = false;
        fetch();
        return () => {
            ignore = true;
        }
    }, []);

    function handleClearBtnClick() {
        setFormKey(formKey + 1);
    }

    function handleAddBtnClick() {
        const data = tryValidateAndGetFormData();
        if (data)
            onAdd(data);
    };

    function handleSaveBtnClick() {
        const data = tryValidateAndGetFormData();
        if (data)
            onSave(data);
    }

    function tryValidateAndGetFormData() {
        if (!formControlRef.current.validate()) {
            setSnackbarData({
                severity: "error",
                title: "Ошибка в заполнении!",
                message: "Необходимо исправить отмеченные поля"
            });
            return false;
        }

        return formControlRef.current.getData();
    }

    function tryGetInitData() {
        return formData;
    }

    function renderFooter(props) {
        return renderFooterFunc ? renderFooterFunc(props) : <BaseSimpleItemEditorFooter {...props}/>
    }

    return (
        <div className={cl.main}>
            <BaseSimpleItemEditorHeader
                isAddSubMode={true}
                customTextFunc={() => "Добавление новой записи (на основе заявки)"}
            />
            <div className={cl.scrollContent}>
                {isLoading && <LinearProgress/>}
                {!isLoading && errorMessage && <Alert variant="outlined" severity="error">{errorMessage}</Alert>}
                {!isLoading && !errorMessage && <EventsMuseumItemForm
                    key={formKey}
                    initData={formData}
                    draftData={draftFormData}
                    controlRef={formControlRef}
                    pageOptions={{kultural_goal: "museum"}}
                    setSnackbarData={setSnackbarData}
                    setLoadingOverlayData={setLoadingOverlayData}
                    readOnlyMode={false}
                />}
            </div>
            {!isLoading && !errorMessage && renderFooter({
                isAddSubMode: true,
                onAddBtnClick: handleAddBtnClick,
                onClearBtnClick: handleClearBtnClick,
                onSaveBtnClick: handleSaveBtnClick,
                onDeleteBtnClick: onDelete,
                readOnlyMode: false,
            })}
        </div>
    );
});

export default EventDraftsNewEventItemEditor;